import { render, staticRenderFns } from "./postsList.vue?vue&type=template&id=d23b3340"
import script from "./postsList.vue?vue&type=script&lang=js"
export * from "./postsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports